// Link zum Backoffice in der Fußzeile der Seitenleiste (Runde 8, Agent 8D; N16). Die Adresse holt die Komponente über
// `betriebApi.backofficeLink()` (`GET /api/betrieb/backoffice-link`) einmal je Anmeldung; ein kleines Symbol öffnet das Backoffice
// in einem neuen Tab. Gibt der Server keine Adresse zurück (kein Recht, kein Server), zeigt die Komponente nichts.
import { useEffect, useState } from "react";
import { betriebApi } from "../api/betrieb";
import { beimNutzerwechsel } from "../daten/sitzung";
import { T8D } from "../textbausteine/texte";
import { Icon } from "./Icon";

let gemerkt: Promise<string | null> | null = null;
beimNutzerwechsel(() => {
  gemerkt = null;
});

function adresse(): Promise<string | null> {
  gemerkt ??= betriebApi
    .backofficeLink()
    .then((r) => r.url)
    .catch(() => null);
  return gemerkt;
}

export function BackofficeLink() {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let aktiv = true;
    void adresse().then((u) => {
      if (aktiv) setUrl(u);
    });
    return () => {
      aktiv = false;
    };
  }, []);
  if (!url) return null;
  return (
    <a className="nav__mini nav__mini--fuss" href={url} target="_blank" rel="noopener noreferrer" title={T8D.backoffice.titel} aria-label={T8D.backoffice.titel}>
      <Icon name="extern" groesse={16} />
    </a>
  );
}
